module.exports = __webpack_public_path__ + "static/img/14000303.4325783f.png";